export default __webpack_public_path__ + "static/media/gsa_contract.70c45fce.jpg";